module.exports = __webpack_public_path__ + "static/media/InvitationMaker-1.d1f44d03.webp";